import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getAddresses } from '../addressService'

export const useAddresses = () => {
  const { data: loggedUser } = useCurrentUser()
  return useQuery({
    queryKey: [QUERY_KEYS.ADDRESSES],
    queryFn: () => getAddresses(),
    enabled: !!loggedUser?.id,
  })
}
